import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { appslice } from "../../stores/slices/app";

const { REACT_APP_APP_NAME } = process.env;

const MetaHead = ({ title, description, keywords }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appslice.actions.setPageTitleAction(title));
  }, [title]);

  return (
    <Helmet>
      <title>
        {title ? `${title} | ${REACT_APP_APP_NAME}` : `${REACT_APP_APP_NAME}`}
      </title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  );
};

export default MetaHead;
